var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.7517,
    r: 17.8125,
    fill: "#EEF0F2",
    stroke: "white",
    strokeWidth: 0.375
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4065_7856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5002 9.75171C15.5302 9.75171 13.1002 12.2717 13.1002 15.3767C13.1002 18.4817 15.5302 21.0017 18.5002 21.0017C21.4702 21.0017 23.9002 18.4817 23.9002 15.3767C23.9002 12.2717 21.4702 9.75171 18.5002 9.75171ZM12.8572 21.0017C9.9952 21.1142 7.7002 23.0717 7.7002 25.5017V27.7517H29.3002V25.5017C29.3002 23.0717 27.0322 21.1142 24.1432 21.0017C22.6852 22.3742 20.6872 23.2517 18.5002 23.2517C16.3132 23.2517 14.3152 22.3742 12.8572 21.0017Z",
    fill: "#8D8D8D",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4065_7856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 18,
    fill: "white",
    transform: "translate(7.7002 9.75171)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.06cc305e86a638766e76ea5dd1b733f7.svg";
export { ForwardRef as ReactComponent };